import { remoteCustomFetcher } from '@/providers/backendClient';
import { CustomPipelineFactory } from '@/providers/dataProvider';

export const dataExportsCustomFetcher: CustomPipelineFactory =
  async ({ sort, filter, page, perPage, signal }) => {
    const result = await remoteCustomFetcher('dataExports', {
      sort,
      filter,
      page,
      perPage,
      signal,
    });

    return result;
  };
